import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Matricola } from '../../../cereri.interface';

@Component({
    selector: 'app-view-matricole-cf',
    templateUrl: './view-matricole-cf.component.html',
    styleUrls: ['./view-matricole-cf.component.scss']
})
export class ViewMatricoleCfComponent {
    filteredMatricole: Matricola[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<ViewMatricoleCfComponent>,
    ) {
        this.filteredMatricole = this.data.matricole_arr.map((id: number) => {
            return this.data.matricole_json.find((matricola: Matricola) => matricola.matricola === id);
        });
    }

    closeDialog(): void {
        this.dialogRef?.close({
            success: false,
        });
    }
}
